import React, { useEffect, useRef, useState } from "react";
import "./menu.css";
import { AnimatePresence, motion } from "motion/react";
import ZoomTransition from "../../common/animations/pageTransition/ZoomTransition";
import { subMenuData } from "./menudata";
import { Link, useNavigate } from "react-router-dom";
import { ArrowDownLeftIcon } from "@heroicons/react/16/solid";
import { handleTopScroll } from "../../common/function/ScroolTop";

const SubMenu = () => {
  const [menuStatus, setMenuStatus] = useState(false);
  const [hoverStatus, setHoverStatus] = useState(false);
  const [index, setIndex] = useState(null);
  const navigate = useNavigate();

  const closeref = useRef();

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (closeref.current && !closeref.current.contains(e.target)) {
        setMenuStatus(false);
      }
    };

    if (menuStatus) {
      document.addEventListener("click", handleClickOutside);
    }

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [menuStatus]);

  const menuvarits = {
    intial: {
      x: -30,
      opacity: 0,
    },
    animate: {
      x: 0,
      opacity: 1,
      transition: {
        duration: 0.5,
        ease: [0.12, 0, 0.39, 0],
      },
    },
    exit: {
      x: -20,

      opacity: 0.5,
      transition: {
        duration: 0.5,
        ease: [0.12, 0, 0.39, 0],
      },
    },
  };

  const iconvariants = {
    intial: {
      transform: "translate(20px,-10px) rotate(50deg)",
      color: "#fec112",
    },
    animate: {
      transform: "translate(0px,0px) rotate(-45deg)",
      color: "#000000",
      transition: {
        duration: 0.5,
        ease: [0.12, 0, 0.39, 0],
      },
    },
    exit: {
      transform: "translate(20px,-10px) rotate(50deg)",
    },
  };

  const containerVarnts = {
    intial: {
      transition: {
        staggerChildren: 0.9,
        staggerDirection: -1,
      },
    },
    open: {
      transtion: {
        delaychildren: 0.5,
        staggerChildren: 0.9,
        staggerDirection: 1,
      },
    },
  };

  const handleNavigate = (p) => {
    navigate(p);
    handleTopScroll();
    setMenuStatus(false);
  };

  const handleMouseOver = (i) => {
    setIndex(i);
    setHoverStatus(true);
  };
  return (
    <div className="realtive w-1/5 flex justify-end items-center -ml-10 ">
      <h2
        className={`text-lg font-semibold cursor-pointer navbar-title ${menuStatus && "navbar-active "}`}
        onClick={(e) => {
          e.stopPropagation(); // Prevents event from bubbling up
          setMenuStatus((prev) => !prev);
        }}
        // onMouseOver={() => setMenuStatus(true)}
        // onMouseOut={() => setMenuStatus(false)}
      >
        Menu <span className="ml-2 text-lg">{menuStatus ? "x" : "="} </span>
      </h2>

      {menuStatus && (
        <AnimatePresence>
          <motion.div
            className="menu-box"
            ref={closeref}
            // onMouseOver={() => setMenuStatus(true)}
            // onMouseOut={() => setMenuStatus(false)}
            onClick={(e) => e.stopPropagation()}
          >
            <motion.div
              variants={containerVarnts}
              initial="initial"
              animate="open"
              exit="initial"
            >
              {subMenuData?.map((v, i) => {
                return (
                  // <Link to={v.path}>
                  <motion.h2
                    variants={menuvarits}
                    animate="animate"
                    initial="intial"
                    exit="exit"
                    transition={{ duration: 0.5, delay: 0.5 }}
                    key={i}
                    onClick={() => handleNavigate(v.path)}
                    onMouseOver={() => handleMouseOver(i)}
                    onMouseOut={() => setIndex(null)}
                    className="flex items-center justify-between "
                  >
                    <span>{v.title}</span>{" "}
                    {index == i && hoverStatus && (
                      <motion.span
                        variants={iconvariants}
                        initial="intial"
                        animate="animate"
                        exit="exit"
                        transition={{ duration: 0.5 }}
                      >
                        {<ArrowDownLeftIcon className="w-10 h-10" />}
                      </motion.span>
                    )}
                  </motion.h2>
                  // </Link>
                );
              })}
            </motion.div>
          </motion.div>
        </AnimatePresence>
      )}
    </div>
  );
};

export default SubMenu;
